module.exports = __webpack_public_path__ + "static/media/vibro_logo.fe6308c6.svg";